import React from 'react';

export type HeaderPill = {
    label: string;
    value: string | number;
};

export interface CardHeaderProps {
    pills: HeaderPill[];
    actions?: {
        label: string;
        onClick: () => void;
    }[];
}

/**
 * Generic card header component with pill-style labels and values.
 * 
 * Useful for:
 * - Job cards
 * - Booking summaries
 * - Invoice cards
 * - Any card that needs labeled key-value pairs in the header
 * 
 * **Styling:** Uses `.timesheet-booking-card__header` and `.timesheet-booking-pill` classes
 * (currently defined in payroll.style.scss). When moving to common/, consider renaming to
 * `.card-header` and `.card-pill` or extracting styles to a shared stylesheet.
 */

export const CardHeader: React.FC<CardHeaderProps> = React.memo(({ pills, actions }) => (
    <div className="timesheet-booking-card__header">
        <div className="timesheet-booking-pill-group">
            {pills.map(pill => (
                <div className="timesheet-booking-pill" key={`${pill.label}-${pill.value}`}>
                    <span>{pill.label}</span>
                    <strong>{pill.value}</strong>
                </div>
            ))}
        </div>
        {actions?.length ? (
            <div className="timesheet-booking-card__header-actions">
                {actions.map(action => (
                    <button
                        key={action.label}
                        type="button"
                        className="timesheet-modal__secondary-btn timesheet-booking-card__action"
                        onClick={action.onClick}
                    >
                        {action.label}
                    </button>
                ))}
            </div>
        ) : null}
    </div>
));

CardHeader.displayName = 'CardHeader';

